import React from 'react'
import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'

const PerfectScrollBar = ({ children, options }) => (
  <PerfectScrollbar {...options}>{children}</PerfectScrollbar>
)

export default PerfectScrollBar
